export { ConfirmationWait } from '@src/features/orders/awaiting-confirmation/components/ConfirmationWait';
export { awaitingConfirmationTarget } from '@src/features/orders/awaiting-confirmation/core/awaitingConfirmationTarget';
export type { ConfirmationTarget } from '@src/features/orders/awaiting-confirmation/components/types';
